import { storage } from '@/utils';
import { useContext } from 'react';
import { UserContext } from './UserContext';
import { UserHttp } from '@/services';
import { envConfig } from '@/configs';

export const useUserContext = () => useContext(UserContext);

export const logout = async (username: string) => {
  storage.removeMultiple([
    'TOKEN',
    'REFRESH_TOKEN',
    'PROFILE',
    'SEENED_MESSAGES',
    'reserves-list',
    'smd-survey-data'
  ]);
  let logoutURL = envConfig?.onPremise?.core?.auth?.casLogoutURL;
  console.log('logoutURL', logoutURL);
  try {
    if (!username) return;
    await UserHttp.logout(username);
    if (!logoutURL || logoutURL === '') {
      localStorage.removeItem('new-reserve-mode-api')
      logoutURL = '/';
    }
  }
  catch (_e) {
  }
  window.location.href = logoutURL;
};
